import { useCallback, useContext } from "react";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../navigations/RootNavigation";
import { ErrorComponent } from "../components/ErrorComponent";
import { AuthManagerContext, AuthStatus } from "../contexts/AuthManager";

type NotFoundScreenProps = StackScreenProps<RootStackParamList, "NotFoundScreen">;

export const NotFoundScreen = ({ route, navigation }: NotFoundScreenProps) => {
    const { status } = useContext(AuthManagerContext);

    const { error = new Error(), goBack, isNotFound } = route.params || {};

    const onClose = useCallback(() => {
        if (goBack && navigation.canGoBack()) {
            navigation.goBack();
        } else if (navigation.getState().routes.length > 1) {
            navigation.popToTop();
        } else {
            navigation.reset({
                index: 0,
                routes: [{ name: status === AuthStatus.In ? "Home" : "Welcome" }],
            });
        }
    }, [goBack, navigation, status]);

    return <ErrorComponent error={error} onClose={onClose} isNotFound={isNotFound} />;
};
